
import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/auth";

export interface AdditionalDeviceParams {
  egwDisable: "No";
  egwTermGroup: "KINPOS_GROUP";
  terminalTimeZone: string;
  teleredId?: string;

}

interface Props {
  data?: AdditionalDeviceParams;
  onChange: (data: AdditionalDeviceParams) => void;
  readonly?: boolean;
  deviceType?: string;
}

export const AdditionalDeviceParamsForm: React.FC<Props> = ({
  data,
  onChange,
  readonly,
  deviceType
}) => {

  const { user } = useContext(AuthContext);
  const isReadonly = readonly === true;

  const getDefaultTimeZone = () => {

    if (!user) return "-06:00";

    if (user.country.code === "PAN") return "-05:00";
    if (user.country.code === "CRC") return "-06:00";

    return "-06:00";
  };


  const [form, setForm] = useState<AdditionalDeviceParams>({
    egwDisable: "No",
    egwTermGroup: "KINPOS_GROUP",
    terminalTimeZone: getDefaultTimeZone(),
    teleredId: ""

  });


  /**
   * 1️⃣ Cargar datos cuando vienen del backend
   */
  useEffect(() => {

    if (!data) return;

    setForm(prev => ({
      ...prev,
      ...data
    }));

  }, [data]);


  /**
   * 2️⃣ Setear timezone solo en creación
   */
  useEffect(() => {

    if (!user) return;
    if (data) return;

    onChange(form);

  }, [user]);


  /**
   * 3️⃣ Limpiar TELERED si no es POS
   */
  useEffect(() => {

    if (deviceType === "052-Acq POS level") return;

    if (!form.teleredId) return;

    const updated = {
      ...form,
      teleredId: ""
    };

    setForm(updated);
    onChange(updated);

  }, [deviceType]);





  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {

    if (isReadonly) return;

    const updated = {
      ...form,
      [e.target.name]: e.target.value
    };

    setForm(updated);
    onChange(updated);
  };


  return (

    <>
      {!user.isLafise ?
        (
          <>
            <hr />
            <div className="mb-4">

              <h6 className="mb-3">
                Parámetros Adicionales del Dispositivo
              </h6>


              <div className="row visually-hidden">

                <div className="col-md-4 mb-3">
                  <label className="form-label">EGW_DISABLE</label>
                  <input className="form-control" value="No" disabled />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">EGW_TERMGROUP</label>
                  <input className="form-control" value="KINPOS_GROUP" disabled />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Terminal Time Zone</label>
                  <input
                    name="terminalTimeZone"
                    className="form-control"
                    value={form.terminalTimeZone}
                    onChange={handleChange}
                    disabled={isReadonly}
                  />
                </div>

              </div>


              <div className="row">

                <div
                  className={
                    getDefaultTimeZone() === "-05:00"
                      ? "col-md-6 mb-3"
                      : "col-md-6 mb-3 visually-hidden"
                  }
                >

                  <label className="form-label">
                    TELERED ID (Opcional)
                  </label>

                  <input
                    name="teleredId"
                    className="form-control"
                    value={form.teleredId || ""}
                    onChange={handleChange}
                    disabled={
                      isReadonly ||
                      deviceType !== "052-Acq POS level"
                    }
                  />

                </div>




              </div>




            </div></>) : <></>}
    </>

  );

};
